import { storeToRefs } from 'pinia';

import { useAuthService } from '@/api/authService';
import { useUserStore } from '@/stores/userStore';
import {
	APP_SWITCHER_SLUGS,
	type AppSwitcherSlug,
} from '@teamworksdev/influencer-core';

interface AppSwitcherAppMetaData {
	title: string;
	slug: AppSwitcherSlug;
	icon: string;
}

interface AppSwitcherTargetUrlParams {
	redirect: string;
	redirect_with_token?: boolean;
}

export function useAppSwitcher() {
	const authService = useAuthService();
	const { appSwitcherProfile } = storeToRefs(useUserStore());


	const appsMetaData: AppSwitcherAppMetaData[] = [
		{
			title: 'Hub',
			slug: APP_SWITCHER_SLUGS.HUB,
			icon: '$twi-app-hub',
		},
		{
			title: 'Camps',
			slug: APP_SWITCHER_SLUGS.CAMPS,
			icon: '$twi-app-camps',
		},
		{
			title: 'Inventory Management',
			slug: APP_SWITCHER_SLUGS.INVENTORY,
			icon: '$twi-app-trac',
		},
		{
			title: 'Compliance + Recruiting',
			slug: APP_SWITCHER_SLUGS.ARMS,
			icon: '$twi-app-compliance',
		},
		{
			title: 'Influencer',
			slug: APP_SWITCHER_SLUGS.INFLCR,
			icon: '$twi-app-influencer',
		},
		{
			title: 'General Manager',
			slug: APP_SWITCHER_SLUGS.GM,
			icon: '$twi-app-gm',
		},
		{
			title: 'Collectives',
			slug: APP_SWITCHER_SLUGS.COLLECTIVES,
			icon: '$twi-app-collectives',
		},
		{
			title: 'AMS',
			slug: APP_SWITCHER_SLUGS.AMS,
			icon: '$twi-app-ams',
		},
		{
			title: 'Nutrition',
			slug: APP_SWITCHER_SLUGS.NUTRITION,
			icon: '$twi-app-nutrition',
		},
		{
			title: 'Strength + Conditioning',
			slug: APP_SWITCHER_SLUGS.STRENGTH,
			icon: '$twi-app-strength',
		},
		{
			title: 'Academics',
			slug: APP_SWITCHER_SLUGS.ACADEMICS,
			icon: '$twi-app-academics',
		},
		{
			title: 'Pathways',
			slug: APP_SWITCHER_SLUGS.PATHWAYS,
			icon: '$twi-app-pathways',
		},
		{
			title: 'Pulse',
			slug: APP_SWITCHER_SLUGS.PULSE,
			icon: '$twi-app-pulse',
		},
		{
			title: 'Coaching',
			slug: APP_SWITCHER_SLUGS.COACHING,
			icon: '$twi-app-coaching',
		},
	];



	const switchApp = async (slug: AppSwitcherSlug, params?: AppSwitcherTargetUrlParams) => {
		const url = appSwitcherProfile?.value?.[`${slug}_target_url`];
		if (!url) {
			console.error('No URL provided');
			return;
		}
		try {
			const { token } = await authService.getOutgoingAxleToken();
			const urlParams = new URLSearchParams();
			urlParams.append('token', token);

			if (params?.redirect) {
				urlParams.append('redirect', params.redirect);
			}
			if (params?.redirect_with_token) {
				urlParams.append('redirect_with_token', 'true');
			}

			const outgoingUrl = `${url}?${urlParams.toString()}`;
			window.location.href = outgoingUrl;
		} catch (e) {
			console.error(e);
		}
	};

	return {
		appsMetaData,
		switchApp,
	};
}
